module.exports = __webpack_public_path__ + "static/media/gifting-hero.3e4ed3bc.png";